"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketApiService = void 0;
const ErrorMessage_1 = require("../../Error/ErrorMessage");
const ApiCallError_1 = require("../../Error/ApiCallError");
const WebSocketApiOperations_1 = require("./WebSocketApiOperations");
class WebSocketApiService {
    constructor(webSocketServer) {
        this.webSocketServer = webSocketServer;
        this.operationsInProgress = new Map();
    }
    createConnectionToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.operationsInProgress.get(WebSocketApiOperations_1.WebSocketApiOperations.CreatingConnectionToken)) {
                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericInProgress);
            }
            this.operationsInProgress.set(WebSocketApiOperations_1.WebSocketApiOperations.CreatingConnectionToken, true);
            try {
                const response = yield this.webSocketServer.createConnectionToken({});
                this.operationsInProgress.set(WebSocketApiOperations_1.WebSocketApiOperations.CreatingConnectionToken, false);
                return response;
            }
            catch (_a) {
                throw new ApiCallError_1.ApiCallError(ErrorMessage_1.ErrorMessage.GenericFail);
            }
        });
    }
}
exports.WebSocketApiService = WebSocketApiService;
